import {Colors} from '@blueprintjs/core';

export const COLORS = [
  {name: 'INDIGO', primary: Colors.INDIGO3, secondary: Colors.INDIGO5},
  {name: 'BLUE', primary: Colors.BLUE3, secondary: Colors.BLUE5},
  {name: 'GREEN', primary: Colors.GREEN3, secondary: Colors.GREEN5},
  {name: 'ORANGE', primary: Colors.ORANGE3, secondary: Colors.ORANGE5},
  {name: 'RED', primary: Colors.RED3, secondary: Colors.RED5},
  {name: 'VIOLET', primary: Colors.VIOLET3, secondary: Colors.VIOLET5},
  {name: 'GOLD', primary: Colors.GOLD3, secondary: Colors.GOLD5},
  {name: 'TURQUOISE', primary: Colors.TURQUOISE3, secondary: Colors.TURQUOISE5},
  {name: 'LIME', primary: Colors.LIME3, secondary: Colors.LIME5},
  {name: 'SEPIA', primary: Colors.SEPIA3, secondary: Colors.SEPIA5},
  {name: 'FOREST', primary: Colors.FOREST3, secondary: Colors.FOREST5},
  {name: 'GRAY', primary: Colors.GRAY3, secondary: Colors.GRAY5},
  {name: 'DARK_GRAY', primary: Colors.DARK_GRAY3, secondary: Colors.DARK_GRAY5},
  {name: 'LIGHT_GRAY', primary: Colors.LIGHT_GRAY3, secondary: Colors.LIGHT_GRAY5},
];

export enum COMPARE_TO {
  PREVIOUS_ROW = 'PREVIOUS_ROW',
  ANOTHER_COLUMN = 'ANOTHER_COLUMN',
  NONE = 'NONE',
}

export const COMPARE_TO_OPTIONS = [
  {label: 'Previous Row', value: COMPARE_TO.PREVIOUS_ROW},
  {label: 'Another Column', value: COMPARE_TO.ANOTHER_COLUMN},
  {label: 'None', value: COMPARE_TO.NONE},
];
